export const environment = {
  production: true,
  sentry: 'https://ea56f41adcca483ab3c253803ed16941@sentry.io/1820910',
  photoUrl: 'photos',
  rpcTimeout: 300e3,
};
